import SignaturePad from "signature_pad";
import "./SignaturePadElement.less";

export class SignaturePadElement extends HTMLElement { 
    static tag = "signature-pad";
    private _canvas: HTMLCanvasElement;
    private _signaturePad: SignaturePad;
    private _clear: HTMLButtonElement;
    private _cancel: HTMLButtonElement;
    private _save: HTMLButtonElement;
    private _aperture: HTMLElement;

    connectedCallback() {
        try { 
            if ((<any>window).screen.orientation.lock)
                (<any>window).screen.orientation.lock('landscape');
        } catch (e) { 
            console.warn(e);
        }
        
        this.innerHTML = this.view();
        this._clear = this.querySelector("button[name=clear]");
        this._cancel = this.querySelector("button[name=cancel]");
        this._save = this.querySelector("button[name=save]");
        this._canvas = this.querySelector("canvas");

        

        this._signaturePad = new SignaturePad(this._canvas);
        setTimeout(() => this.resizeCanvas());
        window.addEventListener("resize", this.resizeCanvas);
        this._clear.addEventListener("click", this.onClear);
        this._cancel.addEventListener("click", this.onCancel);
        this._save.addEventListener("click", this.onSave);


        this._aperture = this.closest("aperture-window");
        this._aperture?.addEventListener("window-change", this.resizeCanvas);
    }

    disconnectedCallback() {
        try { 
            if ((<any>window).screen.orientation.unlock)
                (<any>window).screen.orientation.unlock();
        } catch(e) { 
            console.warn(e);
        }

        window.removeEventListener("resize", this.resizeCanvas);
        this._clear.removeEventListener("click", this.onClear);
        this._cancel.removeEventListener("click", this.onCancel);
        this._save.removeEventListener("click", this.onSave);

        this._aperture?.removeEventListener("window-change", this.resizeCanvas);
    }

    private onClear = () => { 
        this._signaturePad.clear();
    }

    private onCancel = () => { 
        this.dispatchEvent(new CustomEvent("close"));
        this.remove();
    }

    private onSave = () => {
        console.log("On save");
        const data = this._signaturePad.toDataURL("image/png");
        this.dispatchEvent(new CustomEvent("save", { detail: data }));
        this.remove();
    }
    
    private resizeCanvas = () => { 
        const ratio =  Math.max(window.devicePixelRatio || 1, 1);
        this._canvas.width = this._canvas.offsetWidth * ratio;
        this._canvas.height = this._canvas.offsetHeight * ratio;
        this._canvas.getContext("2d").scale(ratio, ratio);
        this._signaturePad.clear(); // otherwise isEmpty() might return incorrect value

        // draw a white box on the canvas
        const ctx = this._canvas.getContext("2d");
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, this._canvas.width, this._canvas.height);
    }

    private view = () => `
        <header>
            <div>Skriv venligst dit navn tydeligt med blokbogstaver</div>
            <div>
                <button type=button name=clear>Clear</button>
                <button type=button name=cancel>Cancel</button>
                <button type=button name=save>Save</button>
            </div>
        </header>
        <canvas></canvas>
    `;
}

customElements.define(SignaturePadElement.tag, SignaturePadElement);